import React from 'react';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import { Header } from './Header';
import { useUser } from '../context/UserContext';

export const Layout: React.FC = () => {
  const location = useLocation();
  const { authInitialized, isAuthenticated } = useUser();
  const isRecordPage = location.pathname.startsWith('/record/');

  if (!authInitialized) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-purple-950 to-[#1a0530] relative overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center opacity-5">
          <img
            src="/TSL_Logo.png"
            alt="Logo"
            className="w-[600px] h-[600px] object-contain"
          />
        </div>
        <div className="relative z-10 animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-violet-400"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-b from-purple-950 to-[#1a0530] text-white">
      {!isRecordPage && <Header />}
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
};